import React, { useState, useEffect, useMemo } from "react";
import { Box, Fade } from "@mui/material";
import ResponsiveImage from "./ResponsiveImage";
import useWholesaleWhatsApp from "../hooks/useWholesaleWhatsApp";

import Banner10 from "../assets/banners/banner10.png";
import Banner9 from "../assets/banners/banner9.png";
import Banner11 from "../assets/banners/banner11.png";
import Banner12 from "../assets/banners/imagem12.png";

import useIsMobile from "../hooks/useIsMobile";

import BannerMobile10 from "../assets/banners/BannerMobile10.png";
import BannerMobile9 from "../assets/banners/BannerMobile9.png";
import BannerMobile11 from "../assets/banners/BannerMobile11.png";
import BannerMobile12 from "../assets/banners/BannerMobile12.png";

const Banner = () => {
    const isMobile = useIsMobile();
    const { openWholesaleWhatsApp, loading: wholesaleLoading } = useWholesaleWhatsApp();

    const bannersDesktop = useMemo(
        () => [
            { src: Banner12, wholesale: true },
            { src: Banner10 },
            { src: Banner11 },
            { src: Banner9 },
        ],
        []
    );

    const bannersMobile = useMemo(
        () => [
            { src: BannerMobile12, wholesale: true },
            { src: BannerMobile10 },
            { src: BannerMobile11 },
            { src: BannerMobile9 },
        ],
        []
    );

    const banners = isMobile ? bannersMobile : bannersDesktop;

    const [index, setIndex] = useState(0);
    const [fade, setFade] = useState(true);

    useEffect(() => {
        setIndex(0);
    }, [isMobile]);

    useEffect(() => {
        if (!banners.length || banners.length === 1) return;

        const interval = setInterval(() => {
            setFade(false);

            setTimeout(() => {
                setIndex((prev) => (prev + 1) % banners.length);
                setFade(true);
            }, 600);
        }, 5000);

        return () => clearInterval(interval);
    }, [banners.length]);

    if (!banners.length) return null;

    const current = banners[index];
    const isWholesaleSlide = Boolean(current.wholesale);

    function handleBannerClick() {
        if (!isWholesaleSlide || wholesaleLoading) return;
        openWholesaleWhatsApp();
    }

    function handleBannerKeyDown(e) {
        if (!isWholesaleSlide || wholesaleLoading) return;
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            openWholesaleWhatsApp();
        }
    }

    return (
        <Box
            role={isWholesaleSlide ? "button" : undefined}
            tabIndex={isWholesaleSlide ? 0 : undefined}
            aria-label={
                isWholesaleSlide
                    ? "Comprar com preço de atacado via WhatsApp"
                    : "Banner promocional"
            }
            onClick={handleBannerClick}
            onKeyDown={handleBannerKeyDown}
            sx={{
                width: "100%",
                maxWidth: "100vw",
                height: isMobile
                    ? {
                          xs: "min(90vh, 880px)",
                          sm: "520px",
                          md: "800px",
                      }
                    : {
                          xs: "min(60vh, 380px)",
                          sm: "520px",
                          md: "800px",
                      },
                position: "relative",
                overflow: "hidden",
                cursor: isWholesaleSlide
                    ? wholesaleLoading
                        ? "wait"
                        : "pointer"
                    : "default",
            }}
        >
            <Fade in={fade} timeout={600}>
                <ResponsiveImage
                    src={current.src}
                    alt={
                        isWholesaleSlide
                            ? "Vendas no atacado - contato via WhatsApp"
                            : "Banner promocional"
                    }
                    desktopObjectFit="cover"
                    mobileObjectFit="cover"
                    sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                    }}
                />
            </Fade>

            <Box
                sx={{
                    position: "absolute",
                    inset: 0,
                    background: {
                        xs: "linear-gradient(180deg, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.15) 45%, rgba(0,0,0,0.65) 100%)",
                        md: "linear-gradient(180deg, rgba(0,0,0,0.45) 0%, rgba(0,0,0,0.15) 40%, rgba(0,0,0,0.55) 100%)",
                    },
                    pointerEvents: "none",
                }}
            />
        </Box>
    );
};

export default Banner;
